/**
 * Decorates a modal dialog with fullscreen capabilities.
 *
 * The decorator applies styles and event listeners to handle fullscreen presentation of a modal dialog. Pushstate
 * makes the browser back button close the dialog.
 *
 * @param {Class} Sup The modal dialog class to decorate. Must be (subclass) of type ModalOverlay.
 */
const FullscreenDecorator = Sup =>
    class extends Sup {
        constructor(...props) {
            super(...props);

            // Bind this since it does not override super method
            this._handlePopstate = this._handlePopstate.bind(this);
        }

        show() {
            super.show();
            this._applyTempStyle();
            this._addEventListeners();

            // Push two states onto the stack to prevent the back button from performing a page load
            window.history.replaceState(null, '');
            window.history.pushState(null, '');
        }

        hide() {
            super.hide();
            this._removeTempStyle();
            this._removeEventListeners();

            // Pop the fullscreen state
            window.history.go(-1);
        }

        _applyTempStyle() {
            document.documentElement.style.overflow = document.body.style.overflow =
                'hidden';
            document.documentElement.style.position = document.body.style.position =
                'relative';
            document.documentElement.style.height = document.body.style.height =
                '100%';
        }

        _removeTempStyle() {
            document.documentElement.style.removeProperty('overflow');
            document.documentElement.style.removeProperty('position');
            document.documentElement.style.removeProperty('height');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('position');
            document.body.style.removeProperty('height');
        }

        _addEventListeners() {
            window.addEventListener('keydown', this._handleKeydown, true);
            window.addEventListener('popstate', this._handlePopstate);
        }

        _removeEventListeners() {
            window.removeEventListener('keydown', this._handleKeydown, true);
            window.removeEventListener('popstate', this._handlePopstate);
        }

        _handleKeydown(event) {
            if (event.keyCode === 27 /* Escape */) {
                this.hide();
                event.stopPropagation();
            }
        }

        _handlePopstate() {
            // Re-push fullscreen state, will be popped again later
            window.history.pushState(null, '');

            this.hide();
        }
    };

export default FullscreenDecorator;



// WEBPACK FOOTER //
// ./lib/FullscreenDecorator.js